module.exports = __webpack_public_path__ + "img/heart.e6c3d1a6.svg";